import { render, staticRenderFns } from "./dankal-editor.vue?vue&type=template&id=f3580aee&scoped=true&"
import script from "./dankal-editor.vue?vue&type=script&lang=js&"
export * from "./dankal-editor.vue?vue&type=script&lang=js&"
import style0 from "./dankal-editor.vue?vue&type=style&index=0&id=f3580aee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3580aee",
  null
  
)

export default component.exports